module.exports = __webpack_public_path__ + "img/full01.fdb96d83.svg";